import React, {useContext, useEffect} from 'react'
import {Route,Switch, Redirect} from "react-router-dom";
import { useLocation } from 'react-router-dom'
import './App.css';
import Home from './components/Home'
import Menu from './components/Menu'
import Footer from './components/Footer'
import Profile from './components/Profile'
import About from './components/About'
import SetTitle from './components/SetTitle'
import NewSet from './components/NewSet'
import ViewSet from './components/ViewSet'
import Draw from './components/Draw'
import Find from './components/Find'
import Spaces from './components/Spaces'
import Chat from './components/Chat'
import Explore from './components/Explore'
import Room from './components/Room'
import VideoChat from './components/VideoChat'
import Space from './components/Space'
import {StreamContext, PlanContext} from './Store'
import Requests from './components/Requests'
import SpaceChat from './components/SpaceChat'
import Members from './components/Members'
import PrivacyPolicy from './components/PrivacyPolicy'
import Terms from './components/Terms'
import TutorProfile from './components/TutorProfile'
import Purchase from './components/Purchase'
import ParentPurchase from './components/ParentPurchase'
import Plans from './components/Plans';
import { config } from './server'
import Reviews from './components/Reviews'
import { useAuth0 } from '@auth0/auth0-react';

const MainApp = () => {
    const location = useLocation();
    const [stream] = useContext(StreamContext)
    const [plan, setPlan] = useContext(PlanContext)
    const { user, isLoading } = useAuth0()
    const address = config.url.API_URL

    useEffect(() => {
      const getPlan = async () => {
        const res = await fetch(address + `/api/${user.nickname}/plan`)
        const data = await res.json()
        setPlan(data.plan)
      }
      getPlan()
        if(location.pathname.indexOf('room') === -1 && stream) {
        stream.getTracks().forEach((track) => {
          track.stop();
          stream.getAudioTracks()[0].enabled = false
        });  
        
        }
      }, [location.pathname, stream, setPlan, user, address])


      if (isLoading) {
        return <div>Loading ...</div>;
        }
//                {plan.length === 0 && <Route component={Plans} exact path="/"/>}
    return (
    <div>
        <header className="App-header">
            <Menu/>
            <Switch>
            {plan.length === 0 && <Route component={Plans} exact path="/"/>}
            {plan.length > 2 && <Route component={Home} exact path="/"/>}
                <Redirect from="/login" to="/" />
                <Redirect from="/sign-up" to="/" />
                <Route component={Profile} exact path="/profile"/>
                <Route component={SetTitle} exact path="/create"/>
                <Route component={NewSet} exact path="/addContent"/>
                <Route component={About} exact path="/about/"/>
                {plan === 'parent' && <Route component={Find} exact path="/find"/>}
                <Route component={TutorProfile} exact path="/tutor"/>
                <Route component={Explore} exact path="/explore"/>
                <Route component={Spaces} exact path="/spaces"/>
                <Route component={Reviews} exact path="/:tutor/reviews"/>
                <Route component={PrivacyPolicy} exact path="/privacypolicy"/>
                <Route component={Terms} exact path="/terms"/>
                <Route component={Purchase} exact path="/purchase"/>
                <Route component={ParentPurchase} exact path="/parent-purchase"/>
                <Route path='/videochat' exact component={VideoChat} />
                <Route path='/room/:roomId' component={Room} />
                <Route exact path='/space/:spaceName' component={Space}/>
                <Route component={ViewSet} exact path="/:viewSet"/>
                <Route component={Draw} exact path="/:viewSet/draw"/>
                <Route component={Chat} exact path="/chat/:person"/>
                <Route component={SpaceChat} exact path="/space/:spaceName/chat"/>
                <Route component={Requests} exact path="/space/:spaceName/requests"/>
                <Route component={Members} exact path="/space/:spaceName/members"/>
            </Switch>
           {location.pathname.indexOf('chat') === -1 && <Footer/>}
          </header>
    </div>

    )}

export default MainApp